module.exports = __webpack_public_path__ + "static/media/organizer_13.18b951ea.jpg";